/** @format */

/** @format */
const svgComps = {}; // ./components下的组件

const modules = import.meta.glob('./*.vue', { eager: true });
for (const path in modules) {
	const cname = path.replace(/(\.\/|\.vue)/g, '');
	svgComps[cname] = (modules[path] as any).default;
}

const getSvg = (type: string) => {
	if (!svgComps[`${type}`]) {
		return null;
	} else {
		return svgComps[`${type}`];
	}
};

export { getSvg, svgComps };
